var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCometsRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 306,
    viewBox: "0 0 378 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144.181,
    height: 22.5754,
    rx: 11.2877,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 238.884 46.7952)",
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 17.6088,
    rx: 8.8044,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 262.931 -50)",
    fill: "url(#paint1_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 362.931 -17)",
    fill: "url(#paint2_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 381.931 107)",
    fill: "url(#paint3_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 314.171,
    height: 6.10633,
    rx: 3.05317,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 381.834 61.9683)",
    fill: "url(#paint4_linear)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 60.3848,
    height: 6.10633,
    rx: 3.05317,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 278.865 143)",
    fill: "url(#paint5_linear)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 253.858,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 180.25 -40.3193)",
    fill: "url(#paint6_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 7.72349,
    rx: 3.86174,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 423.724 163.792)",
    fill: "url(#paint7_linear)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 6.61249,
    rx: 3.30624,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 435.931 96)",
    fill: "url(#paint8_linear)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 444.931 -34)",
    fill: "url(#paint9_linear)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 17.6088,
    rx: 8.8044,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 202.733 -102)",
    fill: "url(#paint10_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 150.534,
    y1: 11.2875,
    x2: -6.1308,
    y2: 11.2875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FC9",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 201.081,
    y1: 8.80425,
    x2: -8.18945,
    y2: 8.80423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 328.013,
    y1: 3.05311,
    x2: -13.359,
    y2: 3.05296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 63.0453,
    y1: 3.05311,
    x2: -2.56765,
    y2: 3.05311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 265.043,
    y1: 7.24979,
    x2: -10.7944,
    y2: 7.24975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 201.081,
    y1: 3.86167,
    x2: -8.18945,
    y2: 3.86163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 201.081,
    y1: 3.30618,
    x2: -8.18945,
    y2: 3.30613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 201.081,
    y1: 8.80425,
    x2: -8.18945,
    y2: 8.80423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#046FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCometsRight);
export default __webpack_public_path__ + "static/media/CometsRight.c02f9e156606b515fca91dc64e743a77.svg";
export { ForwardRef as ReactComponent };